const input = document.getElementById("input");
const analyzeButton = document.getElementById("analyzeButton");
const output = document.getElementById("output");
const languageSelect = document.getElementById("languageSelect");

const API_URL =
  process.env.API_URL || "https://openrouter.ai/api/v1/chat/completions";

function escapeHtml(value) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function renderMarkdown(text) {
  const codeBlocks = [];
  const withPlaceholders = text.replace(
    /```(\w+)?\n([\s\S]*?)```/g,
    (_match, lang, code) => {
      const trimmed = code.replace(/\n$/, "");
      const escaped = escapeHtml(trimmed);
      const className = lang ? ` class="language-${lang}"` : "";
      const html = `<pre><code${className}>${escaped}</code></pre>`;
      codeBlocks.push(html);
      return `@@CODEBLOCK_${codeBlocks.length - 1}@@`;
    }
  );

  let html = escapeHtml(withPlaceholders);
  html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  html = html.replace(/`([^`]+?)`/g, "<code>$1</code>");
  html = html.replace(/@@CODEBLOCK_(\d+)@@/g, (_match, index) => {
    return codeBlocks[Number(index)] || "";
  });

  return html;
}

analyzeButton.addEventListener("click", async () => {
  const errorMessage = input.value;
  const language = languageSelect.value;
  output.textContent = "Analyzing...";
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${process.env.API_KEY}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model: "z-ai/glm-4.5-air:free",
      messages: [
        {
          role: "user",
          content: `Explain this error in ${language}: ${errorMessage}`,
        },
        {
          role: "system",
          content:
            process.env.INSTRUCTIONS ||
            "You are an expert software developer who explains error messages clearly and concisely.",
        },
      ],
    }),
  };
  try {
    const response = await fetch(API_URL, options);
    const data = await response.json();
    const content = data?.choices?.[0]?.message?.content || "";
    output.innerHTML = renderMarkdown(content);
  } catch (error) {
    output.textContent = `Error: ${error.message}`;
  }
});
